import { render, staticRenderFns } from "./OwnerDetailsForm.vue?vue&type=template&id=5e7f51fa&scoped=true&"
import script from "./OwnerDetailsForm.vue?vue&type=script&lang=js&"
export * from "./OwnerDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerDetailsForm.vue?vue&type=style&index=0&id=5e7f51fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7f51fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VTextField,VTextarea})
